var _CUSTOM_COD_FORM_PROVINCES = {
  data: {"GUATEMALA":{"GUATEMALA":true,"SANTA CATARINA PINULA":true,"SAN JOSE PINULA":true,"SAN JOSE DEL GOLFO":true,"PALENCIA":true,"CHINAUTLA":true,"SAN PEDRO AYAMPUC":true,"MIXCO":true,"SAN PEDRO SACATEPEQUEZ":true,"SAN JUAN SACATEPEQUEZ":true,"SAN RAYMUNDO":true,"CHUARRANCHO":true,"FRAIJANES":true,"AMATITLAN":true,"VILLA NUEVA":true,"VILLA CANALES":true,"SAN MIGUEL PETAPA":true},"EL PROGRESO":{"GUASTATOYA":true,"MORAZAN":true,"SAN AGUSTIN ACASAGUASTLAN":true,"SAN CRISTOBAL ACASAGUASTLAN":true,"EL JICARO":true,"SANARATE":true},"SACATEPEQUEZ":{"ANTIGUA GUATEMALA":true,"JOCOTENANGO":true,"PASTORES":true,"SUMPANGO":true,"SANTO DOMINGO XENACOJ":true,"SANTIAGO SACATEPEQUEZ":true,"SAN BARTOLOME MILPAS ALTAS":true,"SAN LUCAS SACATEPEQUEZ":true,"SANTA LUCIA MILPAS ALTAS":true,"MAGDALENA MILPAS ALTAS":true,"SANTA MARIA DE JESUS":true,"CIUDAD VIEJA":true,"SAN MIGUEL DUEÑAS":true,"SAN JUAN ALOTENANGO":true,"SAN ANTONIO AGUAS CALIENTES":true,"SANTA CATARINA BARAHONA":true},"CHIMALTENANGO":{"CHIMALTENANGO":true,"SAN MARTIN JILOTEPEQUE":true,"SAN ANDRES ITZAPA":true,"TECPAN GUATEMALA":true,"PATZUN":true,"PATZICIA":true,"SAN JOSE POAQUIL":true,"SANTA CRUZ BALANYA":true,"SAN JUAN COMALAPA":true,"SANTA APOLONIA":true,"PARRAMOS":true,"ZARAGOZA":true,"EL TEJAR":true},"ESCUINTLA":{"ESCUINTLA":true,"PALIN":true,"MASAGUA":true,"GUANAGAZAPA":true,"SAN VICENTE PACAYA":true},"SANTA ROSA":{"CUILAPA":true,"BARBERENA":true,"SANTA ROSA DE LIMA":true,"CASILLAS":true,"ORATORIO":true,"SANTA CRUZ NARANJO":true,"PUEBLO NUEVO VIÑAS":true,"NUEVA SANTA ROSA":true},"SOLOLA":{"SOLOLA":true,"SANTA LUCIA UTATLAN":true,"SAN ANDRES SEMETABAJ":true,"SAN ANTONIO PALOPO":true,"SAN JOSE CHACAYA":true,"MARIA TECUN":true,"LOS ENCUENTROS":true,"SANTA CATARINA PALOPO":true,"SAN JUAN ARGUETA":true,"SAN JORGE LA LAGUNA":true,"CONCEPCION":true,"PANAJACHEL":true,"SANTA CRUZ LA LAGUNA":true},"TOTONICAPAN":{"SANTA LUCIA LA REFORMA":true,"TOTONICAPAN":true,"SAN CRISTOBAL":true,"SAN ANDRES XECUL":true,"SANTA MARIA CHIQUIMULA":true,"SAN FRANCISCO EL ALTO":true,"MOMOSTENANGO":true},"QUETZALTENANGO":{"QUETZALTENANGO":true,"SALCAJA":true,"SAN MARTIN SACATEPEQUEZ":true,"CAJOLA":true,"CONCEPCION CHIQUIRICHAPA":true,"HUITAN":true,"SAN FRANCISCO LA UNION":true,"SAN MIGUEL SIGUILA":true,"OLINTEPEQUE":true,"SAN CARLOS SIJA":true,"SIBILIA":true,"SAN JUAN OSTUNCALCO":true,"SAN MATEO":true,"ALMOLONGA":true,"CANTEL":true,"ZUNIL":true,"COATEPEQUE":true,"GENOVA":true,"COLOMBA":true,"FLORES COSTA CUCA":true,"LA ESPERANZA":true,"PALESTINA DE LOS ALTOS":true},"SUCHITEPEQUEZ":{"MAZATENANGO":true,"CUYOTENANGO":true,"SAN FRANCISCO ZAPOTITLAN":true,"SAN BERNARDINO":true,"SAN JOSE EL IDOLO":true,"SANTO DOMINGO":true,"SAN LORENZO":true,"SAMAYAC":true,"SAN PABLO JOCOPILAS":true,"SAN ANTONIO SUCHITEPEQUEZ":true,"SAN MIGUEL PANAN":true,"SAN GABRIEL":true,"CHICACAO":true,"SANTO TOMAS LA UNION":true,"ZUNILITO":true,"PUEBLO NUEVO":true},"RETALHULEU":{"RETALHULEU":true,"SAN ANDRES VILLA SECA":true,"SAN SEBASTIAN":true,"SAN MARTIN ZAPOTITLAN":true,"SANTA CRUZ MULUA":true,"SAN FELIPE":true,"NUEVO SAN CARLOS":true,"EL ASINTAL":true},"SAN MARCOS":{"SAN LORENZO":true,"MALACATAN":true,"SAN MARCOS":true,"SAN PEDRO SACATEPEQUEZ":true,"SAN ANTONIO SACATEPEQUEZ":true,"SAN CRISTOBAL CUCHO":true,"RIO BLANCO":true,"COMITANCILLO":true,"TAJUMULCO":true,"TEJUTLA":true,"SAN RAFAEL PIE DE LA CUESTA":true,"NUEVO PROGRESO":true,"EL TUMBADOR":true,"EL RODEO":true,"CATARINA":true,"SAN PABLO":true,"EL QUETZAL":true,"LA REFORMA":true,"ESQUIPULAS PALO GORDO":true},"HUEHUETENANGO":{"HUEHUETENANGO":true,"AGUACATAN":true,"SAN SEBASTIAN HUEHUETENANGO":true,"SANTA BARBARA":true,"SAN RAFAEL PETZAL":true,"CHIANTLA":true,"MALACATANCITO":true,"SAN MATEO IXCAN":true,"SANTA CRUZ BARILLAS":true},"QUICHE":{"SANTA CRUZ DEL QUICHE":true,"CHICHE":true,"CHINIQUE":true,"CHAJUL":true,"CHICHICASTENANGO":true,"PATZITE":true,"SAN ANTONIO ILOTENANGO":true,"SAN PEDRO JOCOPILAS":true,"CUNEN":true,"SAN JUAN COTZAL":true,"NEBAJ":true,"SACAPULAS":true},"BAJA VERAPAZ":{"SALAMA":true,"SAN MIGUEL CHICAJ":true,"RABINAL":true,"CUBULCO":true,"SAN JERONIMO":true},"ALTA VERAPAZ":{"COBAN":true,"SAN CRISTOBAL VERAPAZ":true,"TACTIC":true,"SANTA CRUZ VERAPAZ":true,"SAN PEDRO CARCHA":true,"SAN JUAN CHAMELCO":true,"CHISEC":true},"PETEN":{"SAN JOSE":true,"LA LIBERTAD":true,"FLORES":true,"SAN BENITO":true,"SAN ANDRES":true,"SAN FRANCISCO":true,"SANTA ANA":true},"IZABAL":{"PUERTO BARRIOS":true,"MORALES":true},"ZACAPA":{"ZACAPA":true,"TECULUTAN":true,"RIO HONDO":true,"SAN JORGE":true,"ESTANZUELA":true,"HUITE":true},"CHIQUIMULA":{"CHIQUIMULA":true,"JOCOTAN":true,"CAMOTAN":true,"SAN JOSE DE LA ARADA":true,"SAN JUAN ERMITA":true,"SAN JACINTO":true,"IPALA":true},"JALAPA":{"JALAPA":true,"SAN PEDRO PINULA":true,"MONJAS":true},"JUTIAPA":{"JUTIAPA":true,"EL PROGRESO":true,"ZAPOTITLAN":true,"YUPILTEPEQUE":true,"EL ADELANTO":true}},
  startFields: function () {
    try {
      document.querySelector('#_rsi-cod-form-modal-form [data-type="province_country_field"]').value = "";
      _CUSTOM_COD_FORM_PROVINCES.onProvinceChange();
      document.querySelector('#_rsi-cod-form-modal-form [data-type="province_country_field"]').addEventListener("change", _CUSTOM_COD_FORM_PROVINCES.onProvinceChange);
    } catch (e) {
      console.log(e);
    }
  },
  onProvinceChange: function () {
    var value = document.querySelector('#_rsi-cod-form-modal-form [data-type="province_country_field"]').value;
    var html = "";
    if (!_CUSTOM_COD_FORM_PROVINCES.data[value]) {
      html += '<option value="">' + _COD_FORM_CITY_LABEL + '</option>';
      document.querySelector('#_rsi-cod-form-modal-form [data-type="city_country_field"]').innerHTML = html;
      document.querySelector('#_rsi-cod-form-modal-form [data-type="city_country_field"]').value = "";
      return;
    }
    html += '<option value="">' + _COD_FORM_CITY_LABEL + '</option>';
    Object.keys(_CUSTOM_COD_FORM_PROVINCES.data[value]).sort().forEach(function (item) {
      html += '<option value="' + item + '">' + item + '</option>';
    });
    document.querySelector('#_rsi-cod-form-modal-form [data-type="city_country_field"]').innerHTML = html;
    document.querySelector('#_rsi-cod-form-modal-form [data-type="city_country_field"]').value = "";
  }
};

function _COD_FORM_ON_OPEN_INIT_END_DEF() {
  try {
    if (typeof _COD_FORM_ON_OPEN_INIT_END_DEF_COVERAGE === "function") {
      _COD_FORM_ON_OPEN_INIT_END_DEF_COVERAGE();
    }
    var html = "";
    html += '<option value="">' + _COD_FORM_PROVINCE_LABEL + '</option>';
    Object.keys(_CUSTOM_COD_FORM_PROVINCES.data).sort().forEach(function (item) {
      html += '<option value="' + item + '">' + item + '</option>';
    });
    document.querySelector('#_rsi-cod-form-modal-form [data-type="province_country_field"]').innerHTML = html;
    _CUSTOM_COD_FORM_PROVINCES.startFields();
  } catch (e) {
    console.log(e);
  }
}

function _COD_FORM_ON_OPEN_INIT_END_EMBEDDED() {
  try {
    if (typeof _COD_FORM_ON_OPEN_INIT_END_EMBEDDED_COVERAGE === "function") {
      _COD_FORM_ON_OPEN_INIT_END_EMBEDDED_COVERAGE();
    }
    var onTimeout = function () {
      if (typeof _CUSTOM_COD_FORM_PROVINCES !== "undefined") {
        var html = "";
        html += '<option value="">' + _COD_FORM_PROVINCE_LABEL + '</option>';
        Object.keys(_CUSTOM_COD_FORM_PROVINCES.data).sort().forEach(function (item) {
          html += '<option value="' + item + '">' + item + '</option>';
        });
        document.querySelector('#_rsi-cod-form-modal-form [data-type="province_country_field"]').innerHTML = html;
        _CUSTOM_COD_FORM_PROVINCES.startFields();
      } else {
        setTimeout(onTimeout, 500);
      }
    }
    setTimeout(onTimeout, 500);
  } catch (e) {
    console.log(e);
  }
}

function _COD_FORM_ON_OPEN_INIT_END_EMBEDDED_DEF() {
  try {
    if (typeof _COD_FORM_ON_OPEN_INIT_END_EMBEDDED_DEF_COVERAGE === "function") {
      _COD_FORM_ON_OPEN_INIT_END_EMBEDDED_DEF_COVERAGE();
    }
    _COD_FORM_ON_OPEN_INIT_END_EMBEDDED();
  } catch (e) {
    console.log(e);
  }
}

var _COD_FORM_CITY_LABEL = "";
var _COD_FORM_PROVINCE_LABEL = "";

function _COD_FORM_OVERWRITE_INIT() {
  _rsi.s.form.fields.items_array.forEach(function (item) {
    if (item.type == "province_country_field" || item.type == "province") {
      item.type = "province_country_field";
      item.backendFields.name = "province";
      item.backendFields.elementType = "select";
      if (item.n) {
        if (item.n.ph) {
          _COD_FORM_PROVINCE_LABEL = item.n.ph;
        }
      }
      if (!_COD_FORM_PROVINCE_LABEL) {
        _COD_FORM_PROVINCE_LABEL = item.label;
      }
      item.backendFields.options = [{
        label: _COD_FORM_PROVINCE_LABEL,
        value: "",
      }];
    } else if (item.type == "city") {
      item.type = "city_country_field";
      item.backendFields.name = "city";
      item.backendFields.elementType = "select";
      if (item.n) {
        if (item.n.ph) {
          _COD_FORM_CITY_LABEL = item.n.ph;
        }
      }
      if (!_COD_FORM_CITY_LABEL) {
        _COD_FORM_CITY_LABEL = item.label;
      }
      var options = [{
        value: "", label: _COD_FORM_CITY_LABEL
      }];
      item.backendFields.options = options;
    }
  });
  try {
    if (typeof _COD_FORM_OVERWRITE_INIT_COVERAGE === "function") {
      if (!_COD_FORM_OVERWRITE_INIT_COVERAGE()) {
        return false;
      }
    }
  } catch (e) {
    console.log(e);
  }
  return true;
}